import api from '../../api/openstack'

export default {
  namespaced: true,

  state: {
    floating: []
  },

  getters: {
    getFloating: (state) => {
      return state.floating
    }
  },
  actions: {
    async getFloating ({ commit }, loading = 1) {
      if (loading === 1) commit('setLoadingState', true, {root: true})
      await api.floating.getFloating().then((floating) => {
        commit('setFloating', floating)
      })
      if (loading === 1) commit('setLoadingState', false, {root: true})
    },
    async assignFloatingToServer ({ commit }, data) {
      commit('setLoadingState', true, {root: true})
      await api.floating.assignFloatingToServer({ commit }, data)
      commit('setLoadingState', false, {root: true})
    },
    requestNewFloating ({ commit }, data) {
      api.floating.requestNewFloating()
    },
    async deleteFloating ({ commit }, id) {
      commit('setLoadingState', true, {root: true})
      await api.floating.deleteFloating({ commit }, id)
      commit('setLoadingState', false, {root: true})
    }
  },
  mutations: {
    setFloating (state, floating) {
      state.floating = floating
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/floating.js